var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getHeaders } from "../util";
import axios from "axios";
import { AuthClient } from "../auth";
import { errorService } from "../..";
import { ErrorReasonKey, needToLoginErrors, permissionInsufficientErrors, tokenExpiredErrors, } from "../../constants/authErrorDetails";
const AxiosRepository = ({ baseUrl, timeout, tokenRefresh, authErrors = {
    reasonKey: ErrorReasonKey,
    tokenExpired: tokenExpiredErrors,
    permissionInsufficient: permissionInsufficientErrors,
    needToLogin: needToLoginErrors,
}, }) => {
    const headers = getHeaders();
    const repository = axios.create({
        // @ts-ignore
        headers,
        baseURL: baseUrl,
        timeout: timeout,
    });
    repository.defaults.timeout = 30000;
    repository.interceptors.request.use((request) => {
        const token = AuthClient.tokens.accessToken;
        if (token) {
            // @ts-ignore
            request.headers.common["X-Auth-Token"] = token;
        }
        return request;
    }, (error) => error);
    repository.interceptors.response.use((response) => {
        return response;
    }, (error) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const reason = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors[0]) === null || _c === void 0 ? void 0 : _c[authErrors.reasonKey || "reason"];
        if (authErrors.tokenExpired.includes(reason)) {
            let response;
            try {
                response = (yield tokenRefresh()).data.result;
                if ("accessToken" in response === false)
                    throw response;
            }
            catch (err) {
                AuthClient.clearCookies();
                return (Promise.reject(),
                    errorService.show({
                        error: err,
                    }));
            }
            const config = error.config;
            config.headers["X-Auth-Token"] = response.accessToken;
            return yield repository.request(config);
        }
        else if (authErrors.permissionInsufficient.includes(reason)) {
            return (Promise.reject(),
                errorService.show({
                    error,
                }));
        }
        else if (authErrors.needToLogin.includes(reason)) {
            AuthClient.clearCookies();
            return (Promise.reject(),
                errorService.show({
                    error,
                }));
        }
        return Promise.reject(error);
    }));
    return repository;
};
export default AxiosRepository;
//# sourceMappingURL=AxiosRepository.js.map